import { ChevronLeftIcon } from '@chakra-ui/icons'
import { Flex, Center, Box, HStack } from '@chakra-ui/layout'
import { Button, Spacer, Text } from '@chakra-ui/react'
import { FunctionComponent } from 'react'
import { MdAdd } from 'react-icons/md'
import { PageEnum } from '.'
import AddModelHeader from './pickModel/addModelHeader'

interface IProps {
  page: PageEnum
  onClose?: () => void
  setPage: (value: React.SetStateAction<PageEnum>) => void
}

const LightHeader: FunctionComponent<IProps> = ({ page, onClose, setPage }) => {
  return (
    <Flex padding="15px">
      <HStack spacing="2">
        {onClose && (
          <Center>
            <Button onClick={onClose} borderRadius="0" fontSize="xl">
              <ChevronLeftIcon />
            </Button>
          </Center>
        )}
        <Box flex="auto">
          <Text fontSize="lg">{page}</Text>
        </Box>
      </HStack>
      <Spacer />
      {page === PageEnum.PickYourModel && <AddModelHeader setPage={setPage} />}
    </Flex>
  )
}
export default LightHeader
